import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ConfirmationModal = ({ 
  isOpen, 
  toggle, 
  title = "Confirm Action", 
  message = "Are you sure you want to proceed?", 
  onConfirm, 
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "primary",
  cancelColor = "secondary",
  icon = "ni ni-check-bold",
  showCancelButton = true
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    toggle();
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="sm" centered>
      <ModalHeader toggle={toggle}>
        <i className={`${icon} mr-2`}></i>
        {title}
      </ModalHeader>
      <ModalBody>
        {message}
      </ModalBody>
      <ModalFooter>
        <Button color={confirmColor} onClick={handleConfirm}>
          <i className={`${icon} mr-2`}></i>
          {confirmText}
        </Button>
        {showCancelButton && (
          <Button color={cancelColor} onClick={handleCancel}>
            {cancelText}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;
